<template>
  <div class="image-upload">
    <el-upload
      class="upload-component"
      :action="'/api/upload'"
      :headers="uploadHeaders"
      :show-file-list="false"
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      :on-error="handleError"
    >
      <img v-if="modelValue" :src="modelValue" class="preview-image">
      <el-icon v-else class="upload-icon"><Plus /></el-icon>
      <template #tip>
        <div class="upload-tip">{{ tip }}</div>
      </template>
    </el-upload>
  </div>
</template>

<script>
import { Plus } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'

export default {
  name: 'ImageUpload',
  components: {
    Plus
  },
  props: {
    modelValue: String,
    tip: {
      type: String,
      default: '支持 jpg、png 格式，大小不超过 5MB'
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const uploadHeaders = {
      Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
    }

    const handleSuccess = (response) => {
      emit('update:modelValue', response.url)
    }

    const handleError = () => {
      ElMessage.error('上传失败，请重试')
    }

    const beforeUpload = (file) => {
      const isImage = file.type.startsWith('image/')
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isImage) {
        ElMessage.error('只能上传图片文件!')
        return false
      }
      if (!isLt5M) {
        ElMessage.error('图片大小不能超过 5MB!')
        return false
      }
      return true
    }

    return {
      uploadHeaders,
      handleSuccess,
      handleError,
      beforeUpload
    }
  }
}
</script>

<style scoped>
.image-upload {
  width: 100%;
}

.upload-component {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.upload-component:hover {
  border-color: #409eff;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-tip {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
}
</style> 